import { RDate } from "../../../core";
export class RDay {
    constructor(rDate) {
        const daysjs = rDate.raw
            .year(rDate.raw.year())
            .month(rDate.raw.month())
            .date(rDate.raw.date())
            .hour(0)
            .minute(0)
            .second(0)
            .millisecond(0);
        this.raw = new RDate(daysjs, rDate.tz);
    }
    static fromRDate(rDate) {
        return new RDay(rDate);
    }
    static fromUTCString(str) {
        return new RDay(RDate.fromString(str, "UTC"));
    }
    static *range(from, to) {
        let current = from.toRDate();
        while (current.compare(to.toRDate()) <= 0) {
            yield RDay.fromRDate(current);
            current = current.add(1, "day");
        }
    }
    get isToday() {
        return this.raw.isToday;
    }
    get isTomorrow() {
        return this.raw.isTomorrow;
    }
    get weekday() {
        return this.raw.weekday;
    }
    isBefore(other) {
        return this.raw.isBefore(other.raw);
    }
    isAfter(other) {
        return this.raw.isAfter(other.raw);
    }
    isSame(other) {
        return this.raw.isSameDate(other.raw);
    }
    min(other) {
        return this.isBefore(other) ? this : other;
    }
    max(other) {
        return this.isAfter(other) ? this : other;
    }
    // NOTICE: Can be negative to subtract (or create new method to do this)
    addDays(daysNumber) {
        return RDay.fromRDate(this.raw.add(daysNumber, "days"));
    }
    toRDate() {
        return this.raw;
    }
    // TODO: it should be localized?
    toDayAndMonthString() {
        return this.raw.format("DD.MM");
    }
    toString() {
        return this.raw.format("YYYY-MM-DD");
    }
    /**
     * Format with provided template
     */
    format(template) {
        return this.raw.format(template);
    }
}
